module.exports = __webpack_public_path__ + "static/media/carriedAttached.0eebcc6c.png";